const ERROR_MESSAGES = {
  UPDATE_PASSWORD: 'Please check that you entered the correct password.'
};

export default ERROR_MESSAGES;
